var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeriscopeApexClass } from '../apex-classes';
import { PeriscopeApexTrigger } from '../apex-triggers';
import { PeriscopeFieldUpdate } from '../field-updates';
import { PeriscopeFlow } from '../flows';
import { PeriscopeFormulaField } from '../formula-fields';
import { PeriscopePageLayout } from '../page-layouts';
import { PeriscopeProcessBuilder } from '../process-builders';
import { PeriscopeValidationRule } from '../validation-rules';
import { PeriscopeWorkflowRule } from '../workflow-rules';
import { SonarRecord } from '@ui/records';
import { usePeriscopeActions } from '@hooks';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
const renderAutomation = (automation, parentIndex, onClick, showType) => {
    const { sonarObjectType } = automation, periscope = __rest(automation, ["sonarObjectType"]);
    switch (sonarObjectType) {
        case SonarObjectType.SalesforceApexClass:
            return (React.createElement(PeriscopeApexClass, { apex: periscope, key: periscope.sonarObjectId, onApexClick: onClick, showType: showType, sonarObjectType: sonarObjectType }));
        case SonarObjectType.SalesforceApexTrigger:
            return (React.createElement(PeriscopeApexTrigger, { apex: periscope, key: periscope.sonarObjectId, onApexClick: onClick, showType: showType, sonarObjectType: sonarObjectType }));
        case SonarObjectType.SalesforceField:
            return (React.createElement(PeriscopeFormulaField, { formulaField: periscope, key: periscope.sonarObjectId, onFormulaFieldClick: onClick, showType: showType }));
        case SonarObjectType.SalesforceFieldUpdate:
            return (React.createElement(PeriscopeFieldUpdate, { key: periscope.sonarObjectId, onClick: onClick, record: periscope, showType: showType }));
        case SonarObjectType.SalesforceFlow:
            return (React.createElement(PeriscopeFlow, { flow: periscope, key: periscope.sonarObjectId, onFlowClick: onClick, showType: showType }));
        case SonarObjectType.SalesforcePageLayout:
            return (React.createElement(PeriscopePageLayout, { item: periscope, key: periscope.sonarObjectId, onClick: onClick, showType: showType }));
        case SonarObjectType.SalesforceProcessBuilder:
            return (React.createElement(PeriscopeProcessBuilder, { builder: periscope, key: periscope.sonarObjectId, onBuilderClick: onClick, showType: showType }));
        case SonarObjectType.SalesforceValidationRule:
            return (React.createElement(PeriscopeValidationRule, { index: parentIndex, key: periscope.sonarObjectId, onRuleClick: onClick, rule: periscope, showType: showType }));
        case SonarObjectType.SalesforceWorkflowRule:
            return (React.createElement(PeriscopeWorkflowRule, { index: parentIndex, key: periscope.sonarObjectId, onRuleClick: onClick, rule: periscope, showType: showType }));
        default:
            return (React.createElement(SonarRecord, { isActive: periscope.isActive, key: periscope.sonarObjectId, name: periscope.displayName, onClick: () => onClick(periscope), showType: showType, sonarObjectId: periscope.sonarObjectId, sonarObjectType: sonarObjectType }));
    }
};
export const PeriscopeAutomation = ({ automation, parentIndex, showType }) => {
    const { openPeriscope } = usePeriscopeActions();
    const handleAutomationClick = useCallback((sonarObjectType) => (clickedAutomation) => {
        const { displayName, sonarObjectId } = clickedAutomation;
        openPeriscope({
            id: sonarObjectId,
            name: displayName,
            openedFromIndex: parentIndex,
            type: sonarObjectType
        });
    }, [openPeriscope, parentIndex]);
    const { sonarObjectType } = automation;
    const onClick = handleAutomationClick(sonarObjectType);
    return renderAutomation(automation, parentIndex, onClick, showType);
};
